/**
 * Блок «Возможности»: что ещё умеет планировщик, кроме стен. Якорь `#features` —
 * для пунктов меню. Иконки — тонкой линией, в той же манере, что и чертёж.
 */
import "./landing.css";
import { UIKit } from "@/shared/ui";

const at = (seconds: number) => ({ "--d": `${seconds}s` }) as React.CSSProperties;

const FEATURES = [
	{
		title: "3D-вид за один клик",
		text: "Объём строится из того же чертежа: свет, тени, мебель и отделка. Моделировать отдельно ничего не нужно.",
		icon: "M6 11l10-5 10 5v12l-10 5-10-5zM6 11l10 5 10-5M16 16v12",
	},
	{
		title: "Электрика и свет",
		text: "Розетки на нужной грани стены, кабели под прямыми углами, группы освещения считаются по проводке.",
		icon: "M18 4l-8 14h7l-2 10 9-15h-7z",
	},
	{
		title: "Водоснабжение",
		text: "Холодная и горячая вода, трубы в стяжке и выводы на нужной высоте для каждого прибора.",
		icon: "M16 4c5 7 8 11 8 15a8 8 0 0 1-16 0c0-4 3-8 8-15zM12 20a4 4 0 0 0 4 4",
	},
	{
		title: "Каталог 250+ предметов",
		text: "Мебель, сантехника, свет и декор. У каждого типа - варианты моделей и цветов.",
		icon: "M5 13h22v9H5zM7 22v4M25 22v4M8 13V8h16v5",
	},
	{
		title: "Подложка из БТИ",
		text: "Загрузите фото или скан плана, задайте масштаб по одной стене и обведите поверх.",
		icon: "M5 7h22v18H5zM5 20l7-6 6 5 4-3 5 4M21 11.5a1.5 1.5 0 1 0 0 .01",
	},
	{
		title: "Пол, стены, потолки",
		text: "Плитка, ламинат, краска, обои, натяжной и гипсокартонный потолок - по комнатам и сторонам стен.",
		icon: "M5 27h22M5 27V9l11-5 11 5v18M11 27V15h10v12M5 9h22",
	},
];

export const FeaturesSection = () => (
	<section id="features" aria-labelledby="lp-features-title" className="lp-grid-light scroll-mt-4">
		<div className="mx-auto max-w-7xl px-4 py-20 sm:px-8 lg:py-28">
			<div data-reveal className="flex flex-wrap items-end justify-between gap-6">
				<div className="max-w-180">
					<UIKit.Text as="span" className="lp-rise lp-mono block text-xs text-muted">
						Возможности
					</UIKit.Text>
					<h2
						id="lp-features-title"
						className="lp-rise lp-display mt-4 text-landing-section-heading"
						style={at(0.08)}
					>
						Весь ремонт{" "}
						<UIKit.Text as="span" className="lp-outline">
							в одном
						</UIKit.Text>{" "}
						чертеже
					</h2>
				</div>
				<UIKit.Text
					className="lp-rise max-w-90 text-sm leading-copy-relaxed text-muted"
					style={at(0.16)}
				>
					Рисуете один раз - получаете план, развёртки, 3D и PDF. Поменяли в одном месте -
					обновилось везде.
				</UIKit.Text>
			</div>

			<ul className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
				{FEATURES.map((feature, i) => (
					<li
						key={feature.title}
						data-reveal
						className="lp-card rounded-2xl border border-border bg-surface p-6 sm:p-7"
					>
						<div className="lp-rise" style={at((i % 3) * 0.06)}>
							<svg viewBox="0 0 32 32" aria-hidden="true" className="size-9">
								<path
									className="lp-draw"
									d={feature.icon}
									fill="none"
									stroke="#879b83"
									strokeWidth="1.6"
									strokeLinejoin="round"
									strokeLinecap="round"
									pathLength={1}
									style={at(0.2 + (i % 3) * 0.06)}
								/>
							</svg>
							<h3 className="mt-6 text-xl font-semibold tracking-normal">{feature.title}</h3>
							<UIKit.Text className="mt-2 text-sm leading-copy-relaxed text-muted">
								{feature.text}
							</UIKit.Text>
						</div>
					</li>
				))}
			</ul>
		</div>
	</section>
);
